// src/components/CategoryList.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';

const CategoryList = ({ onCategoryDeleted, onEditCategory }) => {
  const [categories, setCategories] = useState([]);
  const [alert, setAlert] = useState({ message: '', type: '' });

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('https://royaleva.hxbindia.com/categories');
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://royaleva.hxbindia.com/categories/${id}`);
      setCategories(categories.filter((category) => category._id !== id));
      onCategoryDeleted();
      setAlert({ message: 'Category deleted successfully!', type: 'success' });
      setTimeout(() => setAlert({ message: '', type: '' }), 3000);
    } catch (error) {
      console.error('Error deleting category:', error);
      setAlert({ message: 'Error deleting category.', type: 'danger' });
      setTimeout(() => setAlert({ message: '', type: '' }), 3000);
    }
  };

  return (
    <div>

<div className="container d-flex justify-content-center ">
<div className="col-md-9 pt-5">
      <h2>Category Records</h2>
      {alert.message && (
        <div className={`alert alert-${alert.type} mt-3`} role="alert">
          {alert.message}
        </div>
      )}
      <ul className="list-group">
        {categories.map((category) => (
          <li key={category._id} className="list-group-item d-flex justify-content-between align-items-center">
            <div>
              <img src={`https://royaleva.hxbindia.com${category.image}`} alt={category.name} className="img-fluid me-3" style={{ maxWidth: '50px' }} />
              <p><b>Category Name:</b> {category.name}</p>
              <p><b>Category Description:</b> {category.description}</p>
            </div>
            <div>
              <button className="btn btn-warning btn-sm me-2" onClick={() => onEditCategory(category)}>Edit</button>
              <button className="btn btn-danger btn-sm" onClick={() => handleDelete(category._id)}>Delete</button>
            </div>
          </li>
        ))}
      </ul>
    </div>
    </div>
    </div>
  );
};

export default CategoryList;
